import Boss from "./Boss";

export default class BossMage extends Boss {
    constructor() {
        super("adversary_mage", Boss.TYPE_MAGE);

        this.scale.set(0.4);

        this.setIdleAnims(["idle"]);
        this.setAttackAnims(["attack"]);
        this.setDamageAnims(["damage"]);
        this.setDefeatAnims(["defeat"]);
        this.setVictoryAnims(["victory"]);
        this.setEnterAnims(["enter"]);

        this._attackSoundName = "sfx_mage_attack_00";
        this._enterSoundName = "sfx_enter_mage";
    }

    init() {
        super.init(P3.utils.selectRandom(["mage1", "mage2"]));
    }
}